import { render, staticRenderFns } from "./PatientsMatrixFilters.vue?vue&type=template&id=15115ec9"
import script from "./PatientsMatrixFilters.vue?vue&type=script&lang=js"
export * from "./PatientsMatrixFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports